import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ThemeProvider } from 'react-jss';
import { ReactNotifications } from 'react-notifications-component';
import { useFullscreen } from 'react-use';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { TourProvider } from '@reactour/tour';
import ThemeContext from '../contexts/themeContext';
import Aside from '../layout/Aside/Aside';
import Wrapper from '../layout/Wrapper/Wrapper';
import Portal from '../layout/Portal/Portal';
import { demoPages } from '../menu';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import useDarkMode from '../hooks/useDarkMode';
import COLORS from '../common/data/enumColors';
// import { getOS } from '../helpers/helpers';
import steps, { styles } from '../steps';
import { userAuth } from '../contexts/userContext';
import { setIn } from 'formik';
import Loader from '../pages/common/vhelper/Loader';
import ErrorBoundary from '../pages/presentation/demo-pages/helper/ErrorBoundaries';
import UiModal from '../modal/Uimodal.js';
import apiServicewt from '../api/apiServicewt.js';
import { getConfig } from '../config';
// import DueDateStatusLoader from '../components/extras/DueDateStatusLoader';
import { DueDateProvider } from '../contexts/dueDateContext';
import { LoginSettingsProvider } from '../contexts/loginSettingsContext';
import GlobalAlertListener from '../components/GlobalAlertListener';

const MaintenanceOverlay = ({ onClose, isOpen }) => {
	return (
		<UiModal isOpen={isOpen}>
			<div
				style={{
					// position: 'fixed',
					// top: 0,
					// left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: 'rgba(0, 0, 0, 0.1)',
					// zIndex: 999,
					color: 'white',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
					textAlign: 'center',
					padding: '20px',
				}}
				onClick={onClose}>
				<h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>⚠️ Service Suspended</h1>
				<p style={{ fontSize: '1.2rem', maxWidth: '750px', lineHeight: '1.6' }}>
					Your subscription payment is overdue, and the services have been temporarily
					suspended. Please complete the payment to restore access. Once we receive the
					payment, your services will be automatically re-enabled.
				</p>
				<p style={{ marginTop: '1px', opacity: 0.8 }}>
					We appreciate your understanding and patience.!
				</p>
			</div>
		</UiModal>
	);
};
const App = () => {
	// getOS();

	/**
	 * Dark Mode
	 */
	const { themeStatus, darkModeStatus } = useDarkMode();
	const [showOverlay, setShowOverlay] = useState(false);

	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};

	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();
	const location = useLocation();
	const [loaderv, setLoaderv] = useState(false);

	// useEffect(() => {
	// 	let authcheck;
	// 	let authcheck2;

	// 	if (token.email) {
	// 		setLoaderv(false);
	// 		authcheck = setInterval(() => {
	// 			//
	// 			(async () => {
	// 				const web_link = process.env.REACT_APP_WEB_LINK;
	// 				//
	// 				const data = { action: 'checkcuslog', email: token.email };
	// 				const res = await fetch(web_link, {
	// 					method: 'post',
	// 					headers: {
	// 						'Content-Type': 'application/json',
	// 						Accept: 'application/json',
	// 						'sdk-authorization': `${token.session_key}`,
	// 					},
	// 					body: JSON.stringify(data),
	// 				});
	// 				const responce = await res.json();
	// 				if (responce.type == 'error') {
	// 					setToken({});
	// 					localStorage.removeItem('user-auth');
	// 					navigate('/');
	// 				}
	// 				//
	// 			})();
	// 		}, 1000 * 60);
	// 	} else {
	// 		setLoaderv(true);
	// 		authcheck2 = setTimeout(() => {
	// 			//
	// 			(async () => {
	// 				const web_link = process.env.REACT_APP_WEB_LINK;
	// 				//
	// 				const data = { action: 'checkcuslog', email: token.email };
	// 				const res = await fetch(web_link, {
	// 					method: 'post',
	// 					headers: {
	// 						'Content-Type': 'application/json',
	// 						Accept: 'application/json',
	// 						'sdk-authorization': `${token.session_key}`,
	// 					},
	// 					body: JSON.stringify(data),
	// 				}).catch(() => {
	// 					setToken({});
	// 					setLoaderv(false);
	// 					localStorage.removeItem('user-auth');
	// 					if(location.pathname === '/landing/forgot' || location.pathname === '/landing/changepw'){
	//
	// 					}else{
	// 						 navigate('/');
	//
	// 					}
	// 					// navigate('/');
	// 				});

	// 				const responce = await res.json();
	//
	// 				if (responce.type == 'error') {
	// 					setToken({});
	// 					setLoaderv(false);
	// 					localStorage.removeItem('user-auth');
	// 					if(location.pathname === '/landing/forgot' || location.pathname === '/landing/changepw'){
	//
	// 					}else{
	// 						 navigate('/');
	//
	// 					}
	// 					// navigate('/');
	// 				} else {
	// 					setLoaderv(false);
	// 				}
	// 			})();
	// 		}, 300);
	// 	}

	// 	return () => {
	// 		clearInterval(authcheck);
	// 		clearTimeout(authcheck2);
	// 	};
	// }, [token.email,location.pathname]);

	// useEffect(() => {
	// 	let cleartime;
	// 	if (!token.email) {
	// 		cleartime = setTimeout(() => {
	// 			navigate('/');
	// 		}, 300);
	// 	}
	// 	return ()=>{
	// 		clearTimeout(cleartime);
	// 	}
	// }, [token.email, location.pathname]);

	/**
	 * Full Screen
	 */
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	/**
	 * Modern Design
	 */
	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	const withOutAsidePages = [
		// demoPages.login.path,
		// demoPages.signUp.path,
		// demoPages.forgot.path,
		// demoPages.changepw.path,
		demoPages.setup.path,
		'/privacy',
		'/terms',
	];
	if (loaderv) {
		return <Loader />;
	}
	return (
		<ErrorBoundary>
			<ThemeProvider theme={theme}>
				<LoginSettingsProvider>
					<DueDateProvider>
						<ToastProvider components={{ ToastContainer, Toast }}>
							<TourProvider
								steps={steps}
								styles={styles}
								showNavigation={false}
								showBadge={false}>
								{/* <DueDateStatusLoader setShowOverlay={showOverlay} /> */}
								{/* <MaintenanceOverlay isOpen={false} /> */}
								<div
									ref={ref}
									className='app'
									style={{
										backgroundColor: darkModeStatus
											? 'var(--bs-body-bg)'
											: '#ececec',
										zIndex: fullScreenStatus && 1,
										overflow: fullScreenStatus && 'scroll',
									}}>
									<GlobalAlertListener />
									<Routes>
										{withOutAsidePages.map((path) => (
											<Route key={path} path={path} />
										))}
										<Route path='*' element={<Aside />} />
									</Routes>
									<Wrapper />
								</div>
								<Portal id='portal-notification'>
									<ReactNotifications />
								</Portal>
							</TourProvider>
						</ToastProvider>
					</DueDateProvider>
				</LoginSettingsProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
};

export default App;
